export default __webpack_public_path__ + "static/Nox6-80d765de21d9ea0a140b077476e8ba7d.png";